import { ACTIVATE_TOOLTIP, DEACTIVATE_TOOLTIP, HIDE_COMPOSE_SUB_MENU, ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP, DEACTIVATE_ADD_BRAND_BUTTON_TOOLTIP, NEW_ACCOUNT_ADDED, DRAFT_LISTING_TOOLTIP } from '../constants/actionTypes';

const INITIAL_STATE = { isActive: false, isOpen: false, isAddBrandButtonTooltip: false, isNewAccountAdded: false, isDraftListingTooltipActive: false };

export default function tooltip(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case ACTIVATE_TOOLTIP:
      return { ...state, isActive: true, isOpen: true }
    case DEACTIVATE_TOOLTIP:
      return { ...state, isActive: false }
    case HIDE_COMPOSE_SUB_MENU:
      return { ...state, isOpen: false }
    case ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP:
        return { ...state, isAddBrandButtonTooltip: true }
    case DEACTIVATE_ADD_BRAND_BUTTON_TOOLTIP:
        return { ...state, isAddBrandButtonTooltip: false }
    case NEW_ACCOUNT_ADDED:
        return { ...state, isNewAccountAdded: action.payload }
    case DRAFT_LISTING_TOOLTIP:
        return { ...state, isDraftListingTooltipActive: action.payload }
    default:
      return state;
  }
}
